import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnInit {

  @Input() messageText: string;
  constructor() { }

  ngOnInit() {}

  replaceAll(text: string, search: string, replacement: string) {
    return text.replace(new RegExp(search, 'g'), replacement)
  }

  showTextAlertBox() {
    const element = document.getElementById('messageBoxId');
    if (typeof(element) !== 'undefined' && element != null) {
      element.innerHTML = this.replaceAll(this.messageText, '\n', '<br>');
    }
  }

}
